<template>
  <section>
    <framed-image :navigate-to="groupImage" :images="groupImages" />
    <div class="mx-2">
      <h2>What size would you like?</h2>
      <div class="buttons">
        <standard-button 
          v-for="item in filteredGroups" :key="item.id"
          @click="setGroup(item.id)"
          :active="value == item.id"
        >{{item.name}}</standard-button>
      </div>
    </div>
  </section>
</template>

<script>
import FramedImage from './FramedImage'
import StandardButton from './StandardButton'
import { filter } from 'lodash'
export default {
  model: {
    value: 'value',
    event: 'input'
  },
  props: {
    value: {},
    groups: {
      type: Array,
      default() {
        return ["mini","big"]
      }
    }
  },
  components: {
    FramedImage,
    StandardButton
  },
  methods: {
    setGroup(id) {
      this.$emit('input',id)
      this.$scrollTo(document.getElementById('box'), 1000, { offset: -50 })
    }
  },
  computed: {
    filteredGroups() {
      return filter(this.$root.$data.groups, o => this.groups.includes(o.id))
    },
    groupImages() {
      if(this.groups.includes("fathers-mini")) {
        return [this.$root.$data.images.cupcake_size_special]
      } else if(this.groups.includes("halloween-mini") || this.groups.includes("halloween-big")) {
        return [this.$root.$data.images.cupcake_size_special]
      } else if(this.groups.includes("christmas-mini") || this.groups.includes("christmas-big")) {
        return [this.$root.$data.images.cupcake_size_special]
      } else if(this.groups.includes("valentines-mini") || this.groups.includes("valentines-big")) {
        return [this.$root.$data.images.cupcake_size_special]
      } else if(this.groups.includes("monthers-mini") || this.groups.includes("monthers-big")) {
        return [this.$root.$data.images.cupcake_size_special]
      } else {
        return [this.$root.$data.images.cupcake_size]
      }
    },
    groupImage() {
      return 0
    },

  }
}
</script>